module.exports = __webpack_public_path__ + "static/media/Split-Payment.47cc606e.png";